import React, { useEffect, useState } from 'react';

import { nanoid } from '@reduxjs/toolkit';

import { bemCssModules, getTestId } from '@utils';
import { useLocation, useNavigate } from '@utils/hooks';
import { LocationStateType } from '@utils/types';

import { loginActions, useStore } from '@modules';
import { VerifyNextEnum } from '@modules/types';

import Verification from '@containers/Verification';
import EmailTooltip from '@containers/Verification/EmailTooltip';
import LoginLayout from '@layouts/LoginLayout';

import style from './VerifyEmail.scss';

const cn = bemCssModules(style, 'VerifyEmail');
const ti = getTestId('VerifyEmail');

export const VerifyEmail: CustomFC = ({ className }) => {
  const [resendButtonId] = useState(nanoid());
  const navigate = useNavigate();
  const location = useLocation<LocationStateType['login']>();
  const { state } = location;
  const [{ login }, dispatch] = useStore();
  const { loaders } = login;
  const isLoading = !!loaders.verifyEmail || !!loaders.resetPasswordVerifyEmail;
  const isResetPassword = state?.isResetPassword;

  useEffect(() => {
    return () => {
      dispatch(loginActions.clearErrors());
    };
  }, []);

  const handleSubmit = (code: string, key: string) => {
    if (isResetPassword) {
      dispatch(loginActions.resetPasswordVerifyEmail({ code, key }))
        .unwrap()
        .then(res => {
          const next = res.data?.next;
          if (next) navigate(`../${next}`);
        });
    } else {
      dispatch(loginActions.verifyEmail({ code, key }))
        .unwrap()
        .then(res => {
          const next = res.data?.next;
          if (next && next !== VerifyNextEnum.setCountry) {
            navigate(`../${next}`);
          }
        });
    }
  };

  const onBack = () => navigate(CONST.nav.login);

  return (
    <LoginLayout className={cn(null, [className])} data-testid={ti()} backButton={onBack}>
      <div className={cn('content')}>
        <Verification
          onVerify={handleSubmit}
          isLoading={isLoading}
          type="email"
          tooltip={<EmailTooltip id={resendButtonId} />}
          id={resendButtonId}
        />
      </div>
    </LoginLayout>
  );
};

export default VerifyEmail;
